import { createAsyncThunk } from '@reduxjs/toolkit';
import { getKaseyaPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetKaseyaPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getKaseyaPodDataByContactId',
  async ({ psaId, contactId }) =>
    getKaseyaPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
